/**
 * Trunnion AI - Classification Tag Component
 */

import { Shield } from 'lucide-react';
import { getClassificationClasses, getClassificationShortLabel } from '@/lib/classification';
import type { ClassificationLevel } from '@/types';

interface ClassificationTagProps {
  level: ClassificationLevel;
  showIcon?: boolean;
  size?: 'sm' | 'md';
}

export function ClassificationTag({
  level,
  showIcon = true,
  size = 'sm',
}: ClassificationTagProps) {
  const classes = getClassificationClasses(level);
  const label = getClassificationShortLabel(level);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border font-semibold uppercase tracking-wider ${classes.bg} ${classes.border} ${classes.text} ${
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs'
      }`}
    >
      {showIcon && <Shield className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />}
      {label}
    </span>
  );
}
